<input [(ngModel)]="toggleVal" type="checkbox" id="toggle" class="toggleCheckbox" (change)="update($event)"/>
<label for="toggle" class='toggleContainer'>
  <div class="text-label">Simple</div>   
  <div class="text-label">Advanced</div>
</label>
